/*eslint-disable*/
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  FormControl,
  Icon,
  LinearProgress,
  TextField,
  Typography,
  Chip,
  Avatar,
  Tooltip
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloClient } from "apollo-client";
import { createUploadLink } from "apollo-upload-client";
import avatar from "assets/img/faces/avatar1.jpg";
import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";
import Card from "components/Card/Card.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import CardBody from "components/Card/CardBody.jsx";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import { fileUploadServerPath } from "constants.js";
import gql from "graphql-tag";
import { GetUserId, GetUserToken, Logout } from "helpers/UserHelper";
import { BrokerProfileUpdate } from "queries/Profile/mutations";
import { profileQuery } from "queries/profileQuery";
import { updatePassword } from "queries/updatePassword";
import React, { Component } from "react";
import { compose, graphql, Mutation } from "react-apollo";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { changeAvatar } from "reducers/LoginReducer";
import { showSnack, successWarning } from "reducers/NotificationReducer";
import { Field, reduxForm } from "redux-form";
import store from "store";

const CHANGEAVATAR = "sure-quote/Login/CHANGEAVATAR";

const client = new ApolloClient({
  link: createUploadLink({ uri: "http://www.rhlm.co.za/upload" }),
  cache: new InMemoryCache()
});

const uploadFileMutation = gql`
  mutation($file: Upload!, $id: String!) {
    uploadFileWithId(file: $file, id: $id)
  }
`;

function isEmptyOrSpaces(str) {
  return str === undefined || str === null || str.match(/^ *$/) !== null;
}

const required = value => (value ? undefined : "Required");

class Profile extends Component {
  state = {
    value: 0,
    open: false,
    avatarPath: "",
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
    showInfo: false,
    formInitiazed: false,
    checkValidation: false
  };

  handleStateChange = (event, prop) => {
    this.setState({ [prop]: event.target.value });
  };

  handleClickOpenDialog = () => {
    this.setState({ open: true });
  };

  handleCloseDialog = () => {
    this.setState({
      open: false,
      confirmNewPassword: "",
      newPassword: "",
      oldPassword: ""
    });
  };

  openShowInfo = () => {
    console.log("showInfo: true");
    this.setState({ showInfo: true });
  };

  closeShowInfo = () => {
    console.log("showInfo: false");
    this.setState({ showInfo: false });
  };

  handleResetPassword = () => {
    if (
      isEmptyOrSpaces(this.state.newPassword) ||
      isEmptyOrSpaces(this.state.confirmNewPassword) ||
      isEmptyOrSpaces(this.state.oldPassword)
    ) {
      store.dispatch(
        showSnack({
          message: "Password cannot be empty.",
          color: "danger"
        })
      );
    } else if (this.state.newPassword !== this.state.confirmNewPassword) {
      store.dispatch(
        showSnack({
          message: "Password do not match.",
          color: "danger"
        })
      );
    } else {
      var input = {
        oldPass: this.state.oldPassword,
        newPass: this.state.newPassword,
        brokerId: GetUserId(),
        token: GetUserToken()
      };

      this.props
        .UpdatePassword({
          variables: {
            input
          }
        })
        .then(resp => {
          store.dispatch(
            successWarning({
              open: true,
              title: "Password Updated",
              onConfirm: () => this.setState({ open: false })
            })
          );
        })
        .catch(error => {
          store.dispatch(
            showSnack({
              message: "There was an error updating your password : " + error,
              color: "danger"
            })
          );
        });
    }
  };

  saveChanges = () => {
    if (store.getState().form.BrokerProfile.syncErrors) {
      store.dispatch(
        showSnack({
          message: "Invalid Information",
          color: "danger"
        })
      );
      this.setState({ checkValidation: true });
      this.forceUpdate();
    } else {
      this.setState({ checkValidation: false });

      var input = {
        userId: GetUserId(),
        data: store.getState().form.BrokerProfile.values,
        token: GetUserToken()
      };

      this.props
        .BrokerProfileUpdate({
          variables: {
            input
          }
        })
        .then(resp => {
          store.dispatch(
            successWarning({
              open: true,
              title: "Profile Updated."
            })
          );
        })
        .catch(error => {
          store.dispatch(
            showSnack({
              message: "There was an error updating your profile : " + error,
              color: "danger"
            })
          );
        });
    }
  };

  initializeForm = profile => {
    this.props.initialize({
      email: profile.email,
      name: profile.name,
      surname: profile.surname,
      contactPhoneNumber: profile.sbd_contact_phone,
      contactEmail: profile.sbd_contact_email
    });

    this.setState({ formInitiazed: true });
  };

  render() {
    const { value } = this.state;
    const { classes } = this.props;

    if (this.props.data.loading) {
      return <LinearProgress />;
    }

    var { data } = this.props;
    if (
      data.error &&
      data.error.message &&
      data.error.message === "GraphQL error: invalid token"
    ) {
      Logout();
      return <Redirect to="/app/portal/login" />;
    }

    var profile = JSON.parse(data.BrokerProfile[0].profile);

    if (!this.state.formInitiazed) {
      this.initializeForm(profile);
    }

    let avatarPath = avatar;
    if (this.state.avatarPath !== "") {
      avatarPath = this.state.avatarPath;
    } else if (profile.su_pp_path !== null && profile.su_pp_path !== "") {
      avatarPath = profile.su_pp_path;
    }

    return (
      <div>
        <Grid container>
          <GridItem xs={12} sm={10} md={8} style={{flexBasis: "100%", maxWidth: "100%", margin: 'auto' }}>
            <Card profile>
              <CardAvatar profile className="avatarBackground">
                <img
                  src={avatarPath}
                  alt="..."
                  style={{ width: "130px", height: "130px" }}
                />
              </CardAvatar>

              <CardBody profile>
                <Mutation
                  client={client}
                  mutation={uploadFileMutation}
                  onCompleted={data => {
                    this.setState({ avatarPath: data.uploadFileWithId });
                    store.dispatch(
                      changeAvatar({
                        type: CHANGEAVATAR,
                        props: data.uploadFileWithId
                      })
                    );
                  }}
                >
                  {mutate => (
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        display: "block"
                      }}
                    >
                      <Dropzone
                        style={{
                          width: "fit-content",
                          height: "fit-content",
                          border: "none",
                          margin: "0px auto"
                        }}
                        onDrop={([file]) =>
                          mutate({
                            variables: {
                              file,
                              id: store.getState().login.userID
                            }
                          })
                        }
                      >
                        <Tooltip title="Edit Profile Picture" placement="right">
                          <Chip
                            avatar={
                              <Avatar
                                style={{
                                  backgroundColor: "#6c5cab",
                                  color: "white"
                                }}
                              >
                                <Icon>edit</Icon>
                              </Avatar>
                            }
                            variant="outlined"
                            label={
                              <Typography
                                style={{
                                  color: "white"
                                }}
                              >
                                Edit Picture
                              </Typography>
                            }
                            color="secondary"
                            style={{
                              backgroundColor: "#a59fff",
                              color: "white",
                              position: "relative",
                              top: "-38px",
                              cursor: "pointer"
                            }}
                          />
                        </Tooltip>
                      </Dropzone>
                    </div>
                  )}
                </Mutation>
                <h2 className={classes.cardTitle}>
                  {profile.name} {profile.surname}
                </h2>
                <h4 className={classes.cardTitle} style={{ color: "#858a90" }}>
                  {profile.brokerage}
                </h4>

                <Grid container>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControl fullWidth className="spacedFormControl">
                      <Field
                        component={FormInput}
                        checkValidation={this.state.checkValidation}
                        name="email"
                        label="User Email"
                        readOnly={true}
                      />
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControl fullWidth className="spacedFormControl">
                      <Field
                        component={FormInput}
                        checkValidation={this.state.checkValidation}
                        name="name"
                        label="Name"
                        validate={[required]}
                      />
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControl fullWidth className="spacedFormControl">
                      <Field
                        component={FormInput}
                        checkValidation={this.state.checkValidation}
                        name="surname"
                        label="Surname"
                        validate={[required]}
                      />
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControl fullWidth className="spacedFormControl">
                      <Field
                        component={FormInput}
                        checkValidation={this.state.checkValidation}
                        name="contactPhoneNumber"
                        label="Contact Phone Number"
                      />
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControl fullWidth className="spacedFormControl">
                      <Field
                        component={FormInput}
                        checkValidation={this.state.checkValidation}
                        name="contactEmail"
                        label="Contact Email"
                      />
                    </FormControl>
                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ marginTop: "16px" }}
                  >
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        style={{ textAlign: "left" }}
                      >
                        <Typography variant="subheading">
                          Sure Quote App Code
                        </Typography>
                        <Typography
                          variant="caption"
                          className="typographyLinkBasic"
                          onClick={this.openShowInfo}
                        >
                          What's this?
                        </Typography>
                        <Dialog
                          open={this.state.showInfo}
                          onClose={this.closeShowInfo}
                        >
                          <DialogTitle>{"Sure Quote App Code?"}</DialogTitle>
                          <DialogContent>
                            <DialogContentText>
                              This is the code Sure Quote sends to your clients
                              which they register with to link them to you.
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button
                              onClick={this.closeShowInfo}
                              color="primary"
                              autoFocus
                            >
                              Ok
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6}>
                        <TextField
                          fullWidth
                          defaultValue={profile.sbd_broker_app_code}
                          InputProps={{
                            readOnly: true
                          }}
                        />
                      </Grid>
                    </Grid>
                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    style={{ marginTop: "50px", textAlign: "center" }}
                  >
                    <Button
                      variant="outlined"
                      className="outlinedButton"
                      onClick={() => this.saveChanges()}
                      style={{ color: "#55526f", margin: "0px auto" }}
                    >
                      Save Changes
                      <Icon style={{ marginLeft: "5px" }}>check</Icon>
                    </Button>
                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    style={{ marginTop: "35px", textAlign: "center" }}
                  >
                    <Typography
                      variant="body1"
                      style={{
                        color: "#0000008a"
                      }}
                      className="typographyLinkBasic"
                      onClick={this.handleClickOpenDialog}
                    >
                      Reset Password
                    </Typography>
                    <Dialog
                      open={this.state.open}
                      onClose={this.handleCloseDialog}
                      aria-labelledby="form-dialog-title"
                      className="centerFixedDialog"
                    >
                      <DialogTitle id="form-dialog-title">
                        {"Reset Password"}
                      </DialogTitle>
                      <DialogContent>
                        <TextField
                          label="Old Password"
                          fullWidth
                          onChange={e =>
                            this.handleStateChange(e, "oldPassword")
                          }
                          value={this.state.oldPassword}
                          autoComplete="off"
                          type="password"
                        />
                        <TextField
                          label="New Password"
                          fullWidth
                          onChange={e =>
                            this.handleStateChange(e, "newPassword")
                          }
                          value={this.state.newPassword}
                          autoComplete="off"
                          type="password"
                        />
                        <TextField
                          label="Confirm New Password"
                          fullWidth
                          onChange={e =>
                            this.handleStateChange(e, "confirmNewPassword")
                          }
                          value={this.state.confirmNewPassword}
                          autoComplete="off"
                          type="password"
                        />
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={this.handleCloseDialog}
                          color="primary"
                        >
                          Cancel
                        </Button>
                        <Button
                          onClick={this.handleResetPassword}
                          color="primary"
                        >
                          SAVE
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </GridItem>
                </Grid>
              </CardBody>
            </Card>
          </GridItem>
        </Grid>
      </div>
    );
  }
}

Profile = graphql(profileQuery, {
  options: () => ({ fetchPolicy: "network-only" }),
  props: props => {
    if (props.data.error) {
    }

    return { ...props };
  }
})(Profile);

Profile = connect(state => ({
  brokerId: GetUserId(),
  token: GetUserToken()
}))(Profile);

Profile = graphql(updatePassword)(Profile);

Profile = reduxForm({
  form: "BrokerProfile",
  destroyOnUnmount: true
})(Profile);

Profile = compose(
  graphql(updatePassword, { name: "UpdatePassword" }),
  graphql(BrokerProfileUpdate, { name: "BrokerProfileUpdate" })
)(Profile);

export default withStyles(userProfileStyles)(Profile);



// WEBPACK FOOTER //
// ./src/views/Profile/Profile.jsx